<div>
    <div class="p-grid agreements-container">
        <ng-container *ngFor="let agreement of agreements">
            <div class="p-col-12">
               <!-- <p-checkbox value="agreement.id" label="agreement.text" [(ngModel)]="selectedCities"></p-checkbox>-->

               <label class="kt-checkbox" [ngClass]="{'required': isRequired && !agreement.optional}">
                   <input type="checkbox"
                          (change)="onAcceptAgreement(agreement)"
                          [disabled]="readonly"
                          [(ngModel)]="agreement.value">
                   {{agreement.text}}
                   <span></span>
               </label>

               <p *ngIf="isRequired && !agreement.optional" class="required">Please select this requirements</p>
            </div>
        </ng-container>
    </div>
</div>
